import type { PromptState } from "@repo/types"
import { create } from "zustand"

export const usePromptStore = create<PromptState>((set) => ({
  set: (prompt) => set(() => ({ prompt })),
  clear: () => set(() => ({ prompt: "" })),
  prompt: ""
}))
